import Big from 'big.js';
import { Duration } from 'luxon';
import { TenantOrderLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtJob from '~/tenants/twt/model/TwtJob';
import TwtNucleusConfig from '~/tenants/twt/performable/nucleus/TwtNucleusConfig';
import TwtNucleusJob from '~/tenants/twt/performable/nucleus/TwtNucleusJob';
import TwtNucleusGuidedConfig from '~/tenants/twt/performable/nucleus-guided/TwtNucleusGuidedConfig';

export class TwtNucleusGuidedJob extends TwtJob<typeof TwtNucleusGuidedConfig> {
  get performable() {
    return TwtNucleusGuidedConfig;
  }

  get dependencies() {
    return [TwtNucleusConfig.id];
  }

  get configurable() {
    return true;
  }

  get eligible() {
    return this.orderHasNucleus;
  }

  get media() {
    return PersonaType.OFFICE;
  }

  get startWithin(): Duration | null {
    return Duration.fromObject({ days: 1 });
  }

  defaultValue(): ZodVersionedMetadata<(typeof TwtNucleusGuidedConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      guided: 25,
    };
  }

  revenueLines(): TenantOrderLine[] {
    return [
      {
        amount: new Big(TwtNucleusJob.guided(this.metadata.guided)),
        description: `Guided Tour Packs (${this.metadata.guided})`,
        id: 'guided',
        discountable: true,
        taxable: true,
      },
    ];
  }
}
